import Badge from '../ui/Badge';

export function categoryLabel(category) {
  if (!category) return '';
  const vehicle = category.vehicle_type === 'taxi' ? 'Taxi' : 'Bike';
  const location = category.location === 'outside_uae' ? 'Outside' : 'Inside';
  return `${vehicle} · ${location}`;
}

export default function CategoryBadge({ category }) {
  if (!category) return null;
  return <Badge tone="gray">{categoryLabel(category)}</Badge>;
}
